import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, FileText } from 'lucide-react';
import { companyInfo } from '../mockData';

const StickyBottomBar = ({ onScrollToForm }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show only after user scrolls past hero
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    // Track Facebook Pixel
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Contact', {
        content_name: 'Sticky Bar WhatsApp',
        content_category: 'WhatsApp'
      });
    }
    const message = encodeURIComponent(
      'Assalamualaikum. Saya ingin mendapatkan maklumat lanjut.'
    );
    window.open(`https://wa.me/${companyInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  const handleCall = () => {
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Contact', {
        content_name: 'Sticky Bar Call',
        content_category: 'Phone'
      });
    }
    window.location.href = `tel:${companyInfo.phone}`;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t-2 border-amber-500 shadow-2xl animate-slide-up">
      <div className="grid grid-cols-3 gap-1 p-2">
        {/* Call Button */}
        <button
          onClick={handleCall}
          data-testid="sticky-call-button"
          className="flex flex-col items-center justify-center py-3 px-2 bg-emerald-50 hover:bg-emerald-100 active:scale-95 rounded-lg transition-all duration-200"
        >
          <Phone className="h-5 w-5 text-emerald-700 mb-1" />
          <span className="text-xs font-bold text-emerald-900">Call</span>
        </button>

        {/* Form Button */}
        <button
          onClick={onScrollToForm}
          data-testid="sticky-form-button"
          className="flex flex-col items-center justify-center py-3 px-2 bg-amber-500 hover:bg-amber-600 active:scale-95 rounded-lg transition-all duration-200 shadow-md"
        >
          <FileText className="h-5 w-5 text-emerald-950 mb-1" />
          <span className="text-xs font-bold text-emerald-950">SEMAK</span>
        </button>

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsApp}
          data-testid="sticky-whatsapp-button"
          className="flex flex-col items-center justify-center py-3 px-2 bg-green-500 hover:bg-green-600 active:scale-95 rounded-lg transition-all duration-200 shadow-md"
        >
          <MessageCircle className="h-5 w-5 text-white mb-1" />
          <span className="text-xs font-bold text-white">WhatsApp</span>
        </button>
      </div>
    </div>
  );
};

export default StickyBottomBar;
